import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const renew = async (
    data: AccountModel.PostRenewRequest
): Promise<AccountModel.PostRenewResponse> => {
    let response: AccountModel.PostRenewResponse;

    try {
        response = await Http.Request<AccountModel.PostLoginResponse>({
            method: "PUT",
            url: "/account/reset-password",
            data,
        });
    } catch (error) {
        //  @ts-ignore
        throw Error(error);
        // @todo add user error handler
    }
    return response;
};

export default renew;
